import _ from 'lodash';
import {
  stepCancellationAdditionalExpenseLookup,
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepSnowSportsExpenseLookup,
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepCollisionDamageExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripDelayLookup,
  stepTripInterruptionLookup,
  stepAccidentalDeathAndDismembermentLookup,
  stepMissedConnectionLookup,
  stepBaggageAndPersonalLookup,
  stepSportsEquipmentLookup,
  stepMedicalExpenseCFLookup,
  stepTripCancellationCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  medicalHardshipLookup,
  jobLossHardshipLookup,
  disasterAssistanceHardshipLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepChangesToYourJourneyTrawickLookup,
  stepBaggageAndPersonalItemsStarrLookup,
  stepOtherStarrLookup,
  stepCollisionDamageStarrLookup,
  convertClaimCode,
  stepMedicalExpensesTugoLookup,
  stepOtherTugoLookup,
  stepBaseVictorsMedicalTugoLookup,
} from '../dataMapper/claimCodeMapper';

export const mapDataForClaimType = (data, policyTypeId, jsonVersion, showZurichUHC, policyTypeCode) => {
  const lossOfLifeCode = ['AU-LOLF', 'NZ-LOLF'];
  const isInternationalMedicalType = ['INT-MED-AU', 'INT-MED-NZ'];
  let stepOtherClaimCodeList = stepOtherExpenseLookup.claimCodeList;
  if (isInternationalMedicalType.includes(policyTypeCode)) {
    stepOtherClaimCodeList = stepOtherExpenseLookup.claimCodeList.filter((x) => !lossOfLifeCode.includes(x));
  }

  const cashBankCardsCode = ['NZ-ESN-BC-TD-PSPRT', 'NZ-CASH', 'PI-CA-BC-TD-PASPT', 'PI-CASH'];
  const visitingNewZealandPolicyTypes = ['VISIT-NZ', 'VISIT-NZ-PI'];
  let stepBaggageAndPersonalItemsSCTIList = stepBaggageAndPersonalItemsSCTILookup.claimCodeList;
  if (visitingNewZealandPolicyTypes.includes(policyTypeCode)) {
    stepBaggageAndPersonalItemsSCTIList = stepBaggageAndPersonalItemsSCTILookup.claimCodeList.filter((x) => !cashBankCardsCode.includes(x));
  }

  // Update for ShowTrawickFNOLRefactoring
  const newVersion = jsonVersion > 11;
  const newVersionForOtherCollision = jsonVersion > 12;

  let stepTravelDelayList = stepTravelDelayLookup.claimCodeList;
  let stepTripCancellationAndTripInterruptionExpenseList = stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList;
  let stepChangesToYourJourneyTrawickList = stepChangesToYourJourneyTrawickLookup.claimCodeList;

  // Medical Expenses
  let stepMedicalExpensesList = stepMedicalExpensesExpenseLookup.claimCodeList;
  let stepMedicalExpensesTrawickList = stepMedicalExpenseCFLookup.claimCodeList;
  // Baggage and Personal Items
  let stepBaggageAndPersonalItemsList = stepBaggageAndPersonalItemsExpenseLookup.claimCodeList;
  let stepBaggageAndPersonalItemsStarrList = stepBaggageAndPersonalItemsStarrLookup.claimCodeList;
  // Other
  let stepOtherStarrList = stepOtherStarrLookup.claimCodeList;
  // Collision Damage
  let stepCollisionDamageList = stepCollisionDamageExpenseLookup.claimCodeList;
  let stepCollisionDamageStarrList = stepCollisionDamageStarrLookup.claimCodeList;

  if (newVersion) { // jsonVersion > 11
    stepMedicalExpensesList = stepMedicalExpensesList.filter((x) => !stepMedicalExpensesTrawickList.includes(x));
    stepTravelDelayList = stepTravelDelayList.filter((x) => !stepChangesToYourJourneyTrawickList.includes(x));
    stepTripCancellationAndTripInterruptionExpenseList = stepTripCancellationAndTripInterruptionExpenseList.filter((x) => !stepChangesToYourJourneyTrawickList.includes(x));
  } else {
    stepChangesToYourJourneyTrawickList = stepChangesToYourJourneyTrawickList.filter((x) => !stepTravelDelayList.includes(x) && !stepTripCancellationAndTripInterruptionExpenseList.includes(x));
    stepMedicalExpensesTrawickList = stepMedicalExpensesTrawickList.filter((x) => !stepMedicalExpensesList.includes(x));
  }

  // Update lists based on jsonVersion
  if (newVersionForOtherCollision) { // jsonVersion > 12
    stepBaggageAndPersonalItemsList = stepBaggageAndPersonalItemsList.filter((x) => !stepBaggageAndPersonalItemsStarrList.includes(x));
    stepOtherClaimCodeList = stepOtherClaimCodeList.filter((x) => !stepOtherStarrList.includes(x));
    stepCollisionDamageList = stepCollisionDamageList.filter((x) => !stepCollisionDamageStarrList.includes(x));
  } else {
    stepBaggageAndPersonalItemsStarrList = stepBaggageAndPersonalItemsStarrList.filter((x) => !stepBaggageAndPersonalItemsList.includes(x));
    stepOtherStarrList = stepOtherStarrList.filter((x) => !stepOtherClaimCodeList.includes(x));
    stepCollisionDamageStarrList = stepCollisionDamageStarrList.filter((x) => !stepCollisionDamageList.includes(x));
  }

  const tmp = convertClaimCode([...data], policyTypeId);
  for (let i = 0; i < tmp.length; i++) {
    const isStepCancellationAdditional = (stepCancellationAdditionalExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepPersonalItems = (stepPersonalItemsExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepOverseasMedical = (stepOverseasMedicalExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepRentalVehicle = (stepRentalVehicleExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepSnowSports = (stepSnowSportsExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepOther = (stepOtherClaimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepTripCancellationAndTripInterruption = (stepTripCancellationAndTripInterruptionExpenseList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepBaggageAndPersonalItems = (stepBaggageAndPersonalItemsList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMedicalExpenses = !showZurichUHC && (stepMedicalExpensesList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMedicalExpenseZurich = showZurichUHC && (stepMedicalExpensesList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepPetMedical = (stepPetMedicalExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepCollisionDamage = (stepCollisionDamageList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepPropertyDamage = (stepPropertyDamageExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMedicalExpense = (stepMedicalExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepTripCancellation = (stepTripCancellationLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepTripDelay = (stepTripDelayLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepTripInterruption = (stepTripInterruptionLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepAccidentalDeathAndDismemberment = (stepAccidentalDeathAndDismembermentLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMissedConnection = (stepMissedConnectionLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepBaggageAndPersonal = (stepBaggageAndPersonalLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepSportsEquipment = (stepSportsEquipmentLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMedicalExpenseCF = (stepMedicalExpensesTrawickList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepTripCancellationCF = (stepTripCancellationCFLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepBaggagePersonalEffects = (baggagePersonalEffectsLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepItineraryChange = (itineraryChangeLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMedicalHardship = (medicalHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepCriticalIllness = (medicalHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0 && tmp[i].claimCode === medicalHardshipLookup.criticalIllness.claimCode;
    const isStepDisability = (medicalHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0 && tmp[i].claimCode === medicalHardshipLookup.disability.claimCode;
    const isStepDismemberment = (medicalHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0 && tmp[i].claimCode === medicalHardshipLookup.dismemberment.claimCode;
    const isStepLeaveOfAbsence = (medicalHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0 && tmp[i].claimCode === medicalHardshipLookup.leaveOfAbsence.claimCode;
    const isStepDeath = (medicalHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0 && tmp[i].claimCode === medicalHardshipLookup.death.claimCode;
    const isStepJobLossHardship = (jobLossHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepDisasterAssistanceHardship = (disasterAssistanceHardshipLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepTravelDelay = (stepTravelDelayList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMedicalAndEvacuationSCTI = (stepMedicalAndEvacuationLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepChangesToYourJourneySCTI = (stepChangesToYourJourneyLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepBaggageAndPersonalItemsSCTI = (stepBaggageAndPersonalItemsSCTIList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepCashBankCardsTravelDocumentsAndPassports = (stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepPersonalAccidentSCTI = (stepPersonalAccidentSCTILookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepRentalVehicleExcessSCTI = (stepRentalVehicleExcessSCTILookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepChangesToYourJourney = (stepChangesToYourJourneyTrawickList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepBaggageAndPersonalItemsStarr = (stepBaggageAndPersonalItemsStarrList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepOtherStarr = (stepOtherStarrList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepCollisionDamageStarr = (stepCollisionDamageStarrList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepMedicalExpensesTugo = (stepMedicalExpensesTugoLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepOtherTugo = (stepOtherTugoLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStepBaseVictorsMedicalTugo = (stepBaseVictorsMedicalTugoLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    if (isStepCancellationAdditional) {
      tmp[i].step = 6;
      tmp[i].description = 'Trip Interruption and Travel Delay';
      tmp[i].position = 3;
      tmp[i].codeList = stepCancellationAdditionalExpenseLookup.claimCodeList;
    } else if (isStepPersonalItems) {
      tmp[i].step = 7;
      tmp[i].description = 'Personal Items';
      tmp[i].position = 2;
      tmp[i].codeList = stepPersonalItemsExpenseLookup.claimCodeList;
    } else if (isStepOverseasMedical) {
      tmp[i].step = 8;
      tmp[i].description = 'Overseas Medical';
      tmp[i].position = 1;
      tmp[i].codeList = stepOverseasMedicalExpenseLookup.claimCodeList;
    } else if (isStepRentalVehicle) {
      tmp[i].step = 9;
      tmp[i].description = 'Rental Vehicle';
      tmp[i].position = 4;
      tmp[i].codeList = stepRentalVehicleExpenseLookup.claimCodeList;
    } else if (isStepSnowSports) {
      tmp[i].step = 10;
      tmp[i].description = 'Snow Sports';
      tmp[i].position = 5;
      tmp[i].codeList = stepSnowSportsExpenseLookup.claimCodeList;
    } else if (isStepOther) {
      tmp[i].step = 11;
      tmp[i].description = 'Other';
      tmp[i].position = 11;
      tmp[i].codeList = stepOtherClaimCodeList;
    } else if (isStepTripCancellationAndTripInterruption) {
      tmp[i].step = 18;
      tmp[i].description = 'Trip Cancellation & Trip Interruption';
      tmp[i].position = 9;
      tmp[i].codeList = stepTripCancellationAndTripInterruptionExpenseList;
    } else if (isStepBaggageAndPersonalItems) {
      tmp[i].step = 19;
      tmp[i].description = 'Baggage and Personal Items';
      tmp[i].position = 10;
      tmp[i].codeList = stepBaggageAndPersonalItemsList;
    } else if (isStepMedicalExpenses) {
      tmp[i].step = 20;
      tmp[i].description = 'Medical Expenses';
      tmp[i].position = 6;
      tmp[i].codeList = stepMedicalExpensesList;
    } else if (isStepPetMedical) {
      tmp[i].step = 16;
      tmp[i].description = 'Pet Medical';
      tmp[i].position = 11;
      tmp[i].codeList = stepPetMedicalExpenseLookup.claimCodeList;
    } else if (isStepCollisionDamage) {
      tmp[i].step = 17;
      tmp[i].description = 'Collision Damage';
      tmp[i].position = 12;
      tmp[i].codeList = stepCollisionDamageList;
    } else if (isStepPropertyDamage) {
      tmp[i].step = 18;
      tmp[i].description = 'Property Damage';
      tmp[i].position = 13;
      tmp[i].codeList = stepPropertyDamageExpenseLookup.claimCodeList;
    } else if (isStepMedicalExpense) {
      tmp[i].step = 21;
      tmp[i].description = 'Medical Expenses';
      tmp[i].position = 14;
      tmp[i].codeList = stepMedicalExpenseLookup.claimCodeList;
    } else if (isStepTripCancellation) {
      tmp[i].step = 22;
      tmp[i].description = 'Trip Cancellation';
      tmp[i].position = 15;
      tmp[i].codeList = stepTripCancellationLookup.claimCodeList;
    } else if (isStepAccidentalDeathAndDismemberment) {
      tmp[i].step = 23;
      tmp[i].description = 'AD&D';
      tmp[i].position = 16;
      tmp[i].codeList = stepAccidentalDeathAndDismembermentLookup.claimCodeList;
    } else if (isStepTripDelay) {
      tmp[i].step = 24;
      tmp[i].description = 'Trip Delay';
      tmp[i].position = 17;
      tmp[i].codeList = stepTripDelayLookup.claimCodeList;
    } else if (isStepTripInterruption) {
      tmp[i].step = 25;
      tmp[i].description = 'Trip Interruption';
      tmp[i].position = 18;
      tmp[i].codeList = stepTripInterruptionLookup.claimCodeList;
    } else if (isStepMissedConnection) {
      tmp[i].step = 26;
      tmp[i].description = 'Missed Connection';
      tmp[i].position = 19;
      tmp[i].codeList = stepMissedConnectionLookup.claimCodeList;
    } else if (isStepBaggageAndPersonal) {
      tmp[i].step = 27;
      tmp[i].description = 'Baggage and Personal Effects';
      tmp[i].position = 20;
      tmp[i].codeList = stepBaggageAndPersonalLookup.claimCodeList;
    } else if (isStepSportsEquipment) {
      tmp[i].step = 28;
      tmp[i].description = 'Sports Equipment';
      tmp[i].position = 21;
      tmp[i].codeList = stepSportsEquipmentLookup.claimCodeList;
    } else if (isStepMedicalExpenseCF) {
      tmp[i].step = 29;
      tmp[i].description = 'Medical Expense';
      tmp[i].position = 22;
      tmp[i].codeList = stepMedicalExpensesTrawickList;
    } else if (isStepTripCancellationCF) {
      tmp[i].step = 30;
      tmp[i].description = 'Trip Cancellation';
      tmp[i].position = 23;
      tmp[i].codeList = stepTripCancellationCFLookup.claimCodeList;
    } else if (isStepBaggagePersonalEffects) {
      tmp[i].step = 31;
      tmp[i].description = 'Baggage Personal Effects';
      tmp[i].position = 24;
      tmp[i].codeList = baggagePersonalEffectsLookup.claimCodeList;
    } else if (isStepItineraryChange) {
      tmp[i].step = 32;
      tmp[i].description = 'Itinerary Change';
      tmp[i].position = 25;
      tmp[i].codeList = itineraryChangeLookup.claimCodeList;
    } else if (isStepJobLossHardship) {
      tmp[i].step = 33;
      tmp[i].description = 'Job Loss Hardship';
      tmp[i].position = 26;
      tmp[i].codeList = jobLossHardshipLookup.claimCodeList;
    } else if (isStepDisasterAssistanceHardship) {
      tmp[i].step = 34;
      tmp[i].description = 'Disaster Assistance Hardship';
      tmp[i].position = 27;
      tmp[i].codeList = disasterAssistanceHardshipLookup.claimCodeList;
    } else if (isStepMedicalHardship && isStepCriticalIllness) {
      tmp[i].step = 35;
      tmp[i].description = 'Critical Illness';
      tmp[i].position = 28;
      tmp[i].codeList = [medicalHardshipLookup.criticalIllness.claimCode];
    } else if (isStepMedicalHardship && isStepDisability) {
      tmp[i].step = 36;
      tmp[i].description = 'Disability';
      tmp[i].position = 29;
      tmp[i].codeList = [medicalHardshipLookup.disability.claimCode];
    } else if (isStepMedicalHardship && isStepDismemberment) {
      tmp[i].step = 37;
      tmp[i].description = 'Dismemberment';
      tmp[i].position = 30;
      tmp[i].codeList = [medicalHardshipLookup.dismemberment.claimCode];
    } else if (isStepMedicalHardship && isStepLeaveOfAbsence) {
      tmp[i].step = 38;
      tmp[i].description = 'Leave Of Absence';
      tmp[i].position = 31;
      tmp[i].codeList = [medicalHardshipLookup.leaveOfAbsence.claimCode];
    } else if (isStepMedicalHardship && isStepDeath) {
      tmp[i].step = 39;
      tmp[i].description = 'Death';
      tmp[i].position = 32;
      tmp[i].codeList = [medicalHardshipLookup.death.claimCode];
    } else if (isStepTravelDelay) {
      tmp[i].step = 40;
      tmp[i].description = 'Travel Delay & Missed Connections';
      tmp[i].position = 33;
      tmp[i].codeList = stepTravelDelayList;
    } else if (isStepMedicalAndEvacuationSCTI) {
      tmp[i].step = 41;
      tmp[i].description = 'Medical and evacuation';
      tmp[i].position = 34;
      tmp[i].codeList = stepMedicalAndEvacuationLookup.claimCodeList;
    } else if (isStepChangesToYourJourneySCTI) {
      tmp[i].step = 42;
      tmp[i].description = 'Changes to your journey';
      tmp[i].position = 35;
      tmp[i].codeList = stepChangesToYourJourneyLookup.claimCodeList;
    } else if (isStepBaggageAndPersonalItemsSCTI) {
      tmp[i].step = 43;
      tmp[i].description = 'Baggage and personal items';
      tmp[i].position = 36;
      tmp[i].codeList = stepBaggageAndPersonalItemsSCTILookup.claimCodeList;
    } else if (isStepPersonalAccidentSCTI) {
      tmp[i].step = 44;
      tmp[i].description = 'Personal Accident';
      tmp[i].position = 37;
      tmp[i].codeList = stepPersonalAccidentSCTILookup.claimCodeList;
    } else if (isStepRentalVehicleExcessSCTI) {
      tmp[i].step = 45;
      tmp[i].description = 'Rental vehicle excess';
      tmp[i].position = 38;
      tmp[i].codeList = stepRentalVehicleExcessSCTILookup.claimCodeList;
    } else if (isStepCashBankCardsTravelDocumentsAndPassports) {
      tmp[i].step = 46;
      tmp[i].description = 'Cash, bank cards, travel documents and passports';
      tmp[i].position = 39;
      tmp[i].codeList = stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList;
    } else if (isStepChangesToYourJourney) {
      tmp[i].step = 47;
      tmp[i].description = 'Changes to your journey';
      tmp[i].position = 40;
      tmp[i].codeList = stepChangesToYourJourneyTrawickList;
    } else if (isStepMedicalExpenseZurich) {
      tmp[i].step = 48;
      tmp[i].description = 'Medical Expense';
      tmp[i].position = 41;
      tmp[i].codeList = stepMedicalExpensesList;
    } else if (isStepBaggageAndPersonalItemsStarr) {
      tmp[i].step = 49;
      tmp[i].description = 'Baggage and Personal Items';
      tmp[i].position = 42;
      tmp[i].codeList = stepBaggageAndPersonalItemsStarrList;
    } else if (isStepOtherStarr) {
      tmp[i].step = 50;
      tmp[i].description = 'Other';
      tmp[i].position = 43;
      tmp[i].codeList = stepOtherStarrList;
    } else if (isStepCollisionDamageStarr) {
      tmp[i].step = 51;
      tmp[i].description = 'Collision Damage';
      tmp[i].position = 44;
      tmp[i].codeList = stepCollisionDamageStarrList;
    } else if (isStepMedicalExpensesTugo) {
      tmp[i].step = 52;
      tmp[i].description = 'Medical Expenses';
      tmp[i].position = 45;
      tmp[i].codeList = stepMedicalExpensesTugoLookup.claimCodeList;
    } else if (isStepOtherTugo) {
      tmp[i].step = 53;
      tmp[i].description = 'Other';
      tmp[i].position = 46;
      tmp[i].codeList = stepOtherTugoLookup.claimCodeList;
    } else if (isStepBaseVictorsMedicalTugo) {
      tmp[i].step = 54;
      tmp[i].description = 'Medical Expenses - Visitors to Canada';
      tmp[i].position = 47;
      tmp[i].codeList = stepBaseVictorsMedicalTugoLookup.claimCodeList;
    }
  }
  return _.remove(_.uniqBy(tmp, 'step'), (d) => !!d.step);
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/mapDataForClaimType.js